import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/babe-user"

export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/list`, values);
}

export const Details = async (values) => {
  return await axiosInstance(options).get(`${path}/details?_id=${values}`);
}

export const EditUser = async (values) => {
  return await axiosInstance(options).put(`${path}/update-user`, values);
}

export const Delete = async (values) => {
  console.log(values)
  return await axiosInstance(options).delete(`${path}/delete?_id=${values._id}`);
}

export const ChangeStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/change-status`, values);
}

export const ChangeActivationStatus = async (values) => {
  return await axiosInstance(options).put(`${path}/change-activation-status`, values);
}

export const UpdateNotes = async (values) => {
  return await axiosInstance(options).patch(`${path}/update-notes`, values);
}

